

function About() {
    return (
        <section id="about">
            <h2 className="small-section-title">Om Oss</h2>
            <div className="subsection-title row">
                <h3 id="about-intro">
                    Cerón Honung är ett familjeföretag som sysslar endast med hållbar och kärleksfull biodling.
                </h3>
                <div id="about-intro-text"></div>
            </div>
    </section>
    );
}

export default About;